<script setup>
const props = defineProps({
  height: {
    type: String,
    default: '8vh'
  }
})
</script>

<template>
  <v-container :height="height" class="pa-0" fluid>
    <v-img class="fill-height" src="/header1.jpeg" cover> </v-img>
  </v-container>
</template>
